export const HEADER_STORES_OPEN = 'HEADER_STORES_OPEN';
export const HEADER_STORES_CLOSE = 'HEADER_STORES_CLOSE';

export const openStoresDropDown = () => ({
  type: HEADER_STORES_OPEN
});

export const closeStoresDropDown = () => ({
  type: HEADER_STORES_CLOSE
});
